import { AxiosError } from 'axios';
import { ValidationError } from './validation-error';
import { ApiError } from './api-error';

export function isAxiosError(obj: any): obj is AxiosError {
  const err = obj as AxiosError;

  return !!err.isAxiosError;
}

export function getError(error: Error) {
  if (isAxiosError(error)) {
    if (error.response?.data.title === 'One or more validation errors occurred.') {
      return new ValidationError(error.response.data.errors);
    }
    // Carry the ProblemDetails `errorCode` through so callers can identify a specific failure
    // without matching on the message text. Message stays the `detail`, so existing consumers
    // that only read `.message` are unaffected.
    const errorCode: string | undefined = error.response?.data.errorCode;
    if (error.response?.data.detail) return new ApiError(error.response.data.detail, errorCode);
    if (error.response?.data.title) return new ApiError(error.response.data.title, errorCode);
    return new Error(error.response?.data ?? error.message);
  }

  return error;
}

export function getErrorUnknown(error: unknown) {
  const objError = error as Error;
  return getError(objError);
}
